export default "__VITE_ASSET__a63d937f__"